import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TipoAcumulacionEnum } from 'repository/timekeeper/@types/TypeAccrualEnum';
import { AccrualCode } from 'repository/timekeeper/@types/AccrualCode';
import { FormAccrualCode } from './FormAccrualCode';


interface ReadProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  selectedRecord: AccrualCode;
  reloading?: () => void;
}

export const ReadAccrualCode: FC<ReadProps> = ({ open, setOpen, selectedRecord }) => {
  const { t } = useTranslation();

  return (
    <FormAccrualCode
      open={open}
      setOpen={setOpen}
      rows={[]}
      initialValues={{
        id: (selectedRecord as any)?.id,
        name: selectedRecord?.name,
        abbreviation: selectedRecord?.abbreviation,
        type_accrual: selectedRecord?.type_accrual ?? TipoAcumulacionEnum.HORAS,
        hour_per_day:
          selectedRecord?.type_accrual === TipoAcumulacionEnum.DIAS
            ? (selectedRecord?.hour_per_day as any)
            : undefined,
        allow_manual_edits: selectedRecord?.allow_manual_edits,
        show_code: selectedRecord?.show_code,
      }}
      titleKey={t('accruals.accrual_codes.dialog.titles.show')}
      onSubmit={() => {}}
      readOnly
    />
  );
};